import type { ResteChargeContribution } from '../shared/ResteChargeContribution'

export const ResteChargeContributionTypePublicInterimaire: ReadonlyArray<
  Extract<ResteChargeContribution, 'Investissement' | 'FPE'>
> = ['Investissement', 'FPE'] as const

export const ResteChargeContributionTypePublicInterimaireCDI: ReadonlyArray<
  Extract<ResteChargeContribution, 'Investissement' | 'FPE' | 'FPE10PourcentCDII'>
> = ['Investissement', 'FPE', 'FPE10PourcentCDII'] as const

export type ResteChargeContributionTypePublicInterimaire = (typeof ResteChargeContributionTypePublicInterimaire)[number]
export type ResteChargeContributionTypePublicInterimaireCDI = (typeof ResteChargeContributionTypePublicInterimaireCDI)[number]
